import { styled } from '@mui/material/styles';
import { Box } from 'shared/mui/Box';

export const StyledBox = styled(Box)({
  whiteSpace: 'nowrap',
  marginLeft: '8px',
});
